module.exports = __webpack_public_path__ + "static/media/android2.9c2f435d.jpg";